const months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec']

export default (date) => {
  if (!date) return 'unknown date'

  date = new Date(date)

  return `${date.getDate()} ${months[date.getMonth()]} ${date.getFullYear()} at ${('' + date.getHours()).padStart(2, '0')}:${('' + date.getMinutes()).padStart(2, '0')}`
}
